<template>
	<div class="d-flex align-items-stretch h-100 flex-2">
		<leftnav></leftnav>
		<router-view></router-view>
		<searchDefault/>
	</div>
</template>

<script>

import leftnav from '../left-nav';
import searchDefault from '../search/search-default';

export default {
	name: 'feature',

	components:{
		searchDefault,
		leftnav
	},

	props: {
	},
	computed: {
	},
	methods: {
		
	}
}

</script>


// WEBPACK FOOTER //
// src/components/feature/feature.vue